export const isSuppressedSlotSchema = (
  schema?: string,
  blockedSchemas: string[] = [],
): boolean => {
  return Boolean(schema && blockedSchemas.includes(schema))
}
